export var OmissionModuleText;
(function (OmissionModuleText) {
    OmissionModuleText["NUMBER_SELECTED"] = "Number Selected:";
})(OmissionModuleText || (OmissionModuleText = {}));
export var MaxOmissionsSetting;
(function (MaxOmissionsSetting) {
    MaxOmissionsSetting[MaxOmissionsSetting["NONE"] = 0] = "NONE";
    MaxOmissionsSetting[MaxOmissionsSetting["SOFT"] = 1] = "SOFT";
    MaxOmissionsSetting[MaxOmissionsSetting["HARD"] = 2] = "HARD";
    MaxOmissionsSetting[MaxOmissionsSetting["BOTH"] = 3] = "BOTH";
})(MaxOmissionsSetting || (MaxOmissionsSetting = {}));
